/*
 * @Author: SZM
 * @Date: 2020-03-26 18:27:28
 * @LastEditors: DQL
 * @LastEditTime: 2022-03-07 10:48:15
 // eslint-disable-next-line no-irregular-whitespace
 * @Description: content
 */
import axios from 'axios';
import config from '@/config';

const { workflowCtx, kqxtApi } = config.ctx;

// export const getProcessDef = () => { return axios.get(`${workflowCtx}/workflow/processDef`); };
export const getProcessDef = () => { return axios.get(`${workflowCtx}/wf/processDef/list`); };

export const updateClaimTask = (taskId) => { return axios.get(`${workflowCtx}/workflow/claim/${taskId}`); };

// export const queryProcessTodo = (processType, params) => { return axios.get(`${workflowCtx}/workflow/process/todo/${processType}`, { params: params }); };
export const queryProcessTodo = (processType, params) => { return axios.get(`${kqxtApi}/kqxt/workflow/${processType}`, { params: params }); };

// export const queryProcessHistory = (params) => { return axios.get(`${workflowCtx}/workflow/process/history`, { params: params }); };
export const queryProcessHistory = (params) => { return axios.get(`${kqxtApi}/kqxt/workflow/history`, { params: params }); };

export const getProcessList = (processInsId) => { return axios.get(`${workflowCtx}/workflow/process/${processInsId}`); };

export const getProcessImg = (processInsId) => { return axios.get(`${workflowCtx}/workflow/process/getImage/${processInsId}`); };

// export const getProcessComment = (processInsId) => { return axios.get(`${workflowCtx}/wf/process/comment/${processInsId}`); };
export const getProcessComment = (processInsId) => { return axios.get(`${kqxtApi}/kqxt/workflow/process/comment/${processInsId}`); };

export const getSwjgList = (processInsId, workItemId, params) => { return axios.get(`${workflowCtx}/workflow/getWorkflowSwjgList/${processInsId}/${workItemId}`, { params }); };

export const getGwList = (processInsId, workItemId, params) => { return axios.get(`${workflowCtx}/workflow/getWorkflowGwList/${processInsId}/${workItemId}`, { params }); };

export const getSwryList = (processInsId, workItemId, params) => { return axios.get(`${workflowCtx}/workflow/getWorkflowSwryList/${processInsId}/${workItemId}`, { params }); };

export const completeSelect = (processInsId, workItemId, fd) => { return axios.post(`${workflowCtx}/workflow/complete/${processInsId}/${workItemId}`, fd); };

// export const getMyProcess = (params) => { return axios.get(`${workflowCtx}/myProc/query`, { params }); };
export const getMyProcess = (params) => { return axios.get(`${kqxtApi}/kqxt/workflow/myProc`, { params }); };
